export const StoreKey = 'visibility'

export const visibilityStates = {
  hidden: 'hidden',
  minimized: 'minimized',
  open: 'open',
  initialize: null,
} as const
